import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Router } from '@angular/router';
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FireRoute, FireLocation } from '../components/Routes/new-route/new-route.component';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Terminal } from '../components/Branches/new-branch/new-branch.component';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.baseUrl;
  
  private employeesCollection: AngularFirestoreCollection<Employee>;
  constructor(private router: Router, private afAuth: AngularFireAuth,private http: HttpClient, private afs: AngularFirestore) {
    this.employeesCollection = afs.collection<Employee>('employees');
   }

  public login(userCredential: LoginCredatials) {
  return  this.afAuth.auth.signInWithEmailAndPassword(userCredential.email, userCredential.password);
  }

  public logout() {
    this.afAuth.auth.signOut().then(
      () => {
        window.localStorage.clear();
        this.router.navigate(['/']);
      }
    );
  }

  public register(registerInfo: BusCompany) {
    //  create user firestore doc and set user UId as doc Id
    // Todo: call EndPoint for posting register data return promise

  }
  async getUserdetails(user) {
    var userRole = '';
    await this.getCustomClaim(user.uid).then(
      (customClaim)=>{
        console.log(customClaim);
        
          if(customClaim.claims.superAdmin){
            userRole = 'superAdmin';
            console.log("USer is superAdmin");
            
          }else if(customClaim.claims.admin) {
            userRole = 'admin';
          } else if(customClaim.claims.manager){
            userRole = 'manager'
          }
          else if(customClaim.claims.bookingClerk){
            userRole = 'bookingClerk'
          }else if(customClaim.claims.courierClerk){
            userRole = 'courierClerk'
          }
          console.log( 'userRole Extracted from Auth service' +userRole);        
      }
      
    )
    console.log(userRole);
    console.log(user.uid);
    window.localStorage.setItem('uid',user.uid );
    console.log('UID stored in Storage '+ window.localStorage.getItem('uid'));
    
    const gottenUser =   this.afs.collection<User>('/users', ref => ref.where('id', '==', user.uid)).valueChanges();
    console.log('Logging gotten User: =======>');
    console.log(gottenUser);
    await  gottenUser.subscribe(
      (userz) => {
        userz.forEach(element => {
        window.localStorage.setItem('name', element.name );
        window.localStorage.setItem('email', element.email);
        window.localStorage.setItem('operator', element.operator);
        window.localStorage.setItem('role', element.role);
        console.log('After Subscription User details gotten: ', window.localStorage.getItem('name') ) ;
        console.log('Operator gotten: ', window.localStorage.getItem('operator'));
       });
      }
    );
    console.log('User ID : ' + user.uid);

    await this.afs.collection<User>('/users', ref => ref.where('id', '==', user.uid))
    .snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as User;
        const id = a.payload.doc.id;
        console.log(data);
        console.log( data );
        return { id, ...data };
      }))
    );
    console.log(
    console.log('User details gotten: ', window.localStorage.getItem('name')) ) ;
  }

  async registerEmployee(employee: Employee, password: string, isDriver: boolean) {
    let  RegisterErrors = '';
    await  this.afAuth.auth.createUserWithEmailAndPassword(employee.email, password).then(
      (userCredentials) => {
        // const employeeTmp: Employee = {
        //   id: userCredentials.user.uid,
        //   fname: employee.fname,
        //   email: employee.email,
        //   lname: employee.lname,
        //   age: employee.age,
        //   gender: employee.gender,
        //   phone: employee.phone,
        //   role: employee.role,
        //   image: '',
        //   bus: {
        //     seats: [ {seats: [1, 2, 3, 4, 5]}, {seats: [6, 7, 8, 9, 10]}, {seats: [11, 12, 13, 14, 15]}, {seats: [16, 17, 18, 19, 20]},
        //     {seats: [21, 22, 23, 24, 25]}, {seats: [26, 27, 28, 29, 30]}, {seats: [31, 32, 33, 34, 35]},
        //     {seats: [36, 37, 38, 39, 40]}, {seats: [41, 42, 43, 44, 45]}, {seats: [46, 47, 48, 49, 50]},
        //     {seats: [51, 52, 53, 54, 55]}, {seats: [56, 57, 58, 59, 60]}, {seats: [61, 62, 63, 64, 65]}, ],
        //     numberOfSeats: 65,
        //     lplate: 'UAX 996T',
        //     layout: {
        //       name: '65-Seater',
        //       imageURL:  '',
        //     },
        //     services: [ 'Snacks', 'Water Bottle'],
        //     privillagedSeats: [
        //       {
        //         name: 'Seat-78' ,
        //         seat: 'seat-45'
        //       }
        //     ]
        //   },
        //   operator: {
        //     id: 'One',
        //     name: 'Link Bus Services Limited',
        //     email: 'link@YoBus.com',
        //     contact: 75123456,
        //     location: 'Katwe Uganda',
        //     MMnumber: 751234567,
        //     account:  234566778,
        //     website: 'www.link.ug.com',
        //   }

        // };

        // employee.id = userCredentials.user.uid;
        this.employeesCollection.add(employee).then(
          (doc) => {
            console.log('Document Has been saved ');
          }
        ).catch(
          (err) => {
            RegisterErrors = err.message;
            console.log('Message ' + RegisterErrors);
          }
        );
      }
    ).catch(
      (err) => {
        console.log(err);
        RegisterErrors = err.message;
        console.log('Message ' + RegisterErrors);
      }
    );

    return RegisterErrors;

  }
  isAuthenticated() {
  }
  isAccounts(){
    if(window.localStorage.getItem('role') === 'accounts'){
      return true;
    }
    return false;
  }

  getCustomClaim(uid:string){
    console.log("Inside get Custom claim method  : " + uid);
    const url = this.baseUrl + 'auth/getRole'
    return this.http.post<CustomClaim>(url,{uid:uid}).toPromise();
  }


}
export interface CustomClaim {
 claims: {
  admin: boolean;
  manager: boolean;
  superAdmin: boolean;
  bookingClerk: boolean;
  courierClerk: boolean;
 }
}
interface LoginCredatials {
  email: string;
  password: string;
}
export interface BusCompany {
  name: string ;
  email: string;
  contact: number;
  location: FireLocation;
  MMnumber: number;
  account: number;
  website: string;
}
export interface Employee {
  fname: string;
  email: string;
  lname: string;
  image: string;
  age: number;
  terminal: Terminal;
  gender: string;
  phone: string;
  role: string;
  dateJoined: Date;
  // bus: Bus;
  password: string;
  operator: BusCompany;

}
export interface Bus {
  operator: BusCompany;
  lplate: string;
  layout: BusLayout;
  model: string;
  seats: SeatRow[];
  numberOfSeats: number;
  services: string[];
  privillagedSeats: Privilages[];
  driver: Employee;
  route: FireRoute;

}
export interface SeatRow {
  seats: number[];
}
export interface BusLayout {
  numberOfSeats: number;
  name: string;
  imageURL: string;
}
export interface Privilages {
  name: string;
  privillages: string [];
}
export interface OperatorRoute {
  id: string;
  to: string;
  from: string;
  departure: string;
  arrival: string;
  toGPS: {
    lat: number;
    lng: number;
  };
  fromGPS: {
    lat: number;
    lng: number;
  };

}
export interface Passenger {
  fname: string;
  lname: string;
  age: number;
  gender: string;
  email: string;
  phone: string;
  times : number;
}
export interface Booking {
  trip: string;
  bus: Bus;
  passenger: Passenger;
  methodOfPayment: string;
  amount: number;
  luggage: { content: string, charge: number};
  coupon: string;
  MMphone: string;
  cardHolder: string;
  cardNo: string;
  expiry: string;
  CVV: string;
  seats: number[];
  status: string;
  timestamp: Date;
  bookedBy: string;
}
export interface User {
  name: string;
  email: string;
  phone_number: string;
  role: string;
  operator: string;
}
export interface Trip {
  bus: Bus;
  fare: number;
  bookedSeats: number[];
  passengers: Passenger [];
  expenditure: Expenditure;
  date: Date;
  status: string;
}

export interface Expenditure {
  loadingCharges: number;
  brokerCharges: number;
  fuel: number;
  nightParking: number;
  washing: number;
  accomodation: { conductor: number; driver: number};
  majorStages: number;
  others: number;
}
export interface Fare {
  route: FireRoute;
  mon: number;
  tue: number;
  wed: number;
  thur: number;
  fri: number;
  sat: number;
  sun: number;
}

export interface DailyCollection{
  date: string;
  lastUpdatedAt: Date;
  collection: number;
  collector: string;
  operator:string;
  bookings: number;
}
